import appStore from 'store';
import api from './api';

const store = {
    namespaced: true,
    state:{
        accountTotal:0,
        accountList:[],
        confTotal:0,
        confList:[],
        total:0,
        listInfo:[],
    },
    mutations:{
        setAccountTotal(state,payload) {
            state.accountTotal = payload;
        },
        setAccountList(state,payload) {
            state.accountList = payload;
        },
        setConfTotal(state,payload) {
            state.confTotal = payload;
        },
        setConfList(state,payload) {
            state.confList = payload;
        },
        setTotal(state,payload) {
            state.total = payload;
        },
        setListInfo(state,payload) {
            state.listInfo = payload;
        }
    },
    actions:{
        queryList({commit},data) {
            api.getList(data).then(response =>{
               commit('setAccountTotal',response.data.totalCount);
               commit('setAccountList',response.data.list);
            })
        },
        queryReconConf({commit},data) {
            api.getReconConf(data).then( response =>{
                commit('setTotal',response.data.totalCount);
                commit('setListInfo',response.data.list);
            })
        }
    }
}

appStore.registerModule('account', store);